import { IconAngleLeft } from '@iwoca/icons';

import { useGetStateQuery } from '../../api/lendingApi/lendingApiQueries';
import { SIGNUP_STEPS_DIRECT_UK } from '../../constants';
import { useSignupRouterUK } from '../../hooks/useSignupRouter/useSignupRouterUK';
import { useSplitTestContext } from '../../hooks/useSplitTestContext';
import { TSignupStepsUK } from '../../types';
import { Button } from '../Button/Button';
import {
  APPLICANT_STEP_ID,
  BUSINESS_STEP_ID,
  CHECK_STEP_ID,
  COMPANY_QUESTIONS_STEP_ID,
  DOCUMENTS_STEP_ID,
  GET_STARTED_STEP_ID,
} from '../helpers/steps';

/**
 * BackToStep component is only rendered for direct customer UK signup.
 */
const BackToStep = () => {
  const { navigateSignup, currentStep } = useSignupRouterUK();
  const { isStateFetching, isStateLoading } = useGetStateQuery();
  const { hasAIQuestionSignupEnabled } = useSplitTestContext();

  const getPreviousStep = (currentStep: string): TSignupStepsUK => {
    const SIGNUP_STEPS = hasAIQuestionSignupEnabled
      ? SIGNUP_STEPS_DIRECT_UK
      : SIGNUP_STEPS_DIRECT_UK.filter(
          (step) => step !== COMPANY_QUESTIONS_STEP_ID,
        );

    const currentStepIndex = SIGNUP_STEPS.findIndex(
      (step) => step === currentStep,
    );

    if (currentStep === CHECK_STEP_ID) {
      return BUSINESS_STEP_ID;
    }

    if (currentStep === DOCUMENTS_STEP_ID) {
      return APPLICANT_STEP_ID;
    }

    if (currentStepIndex > 0) {
      return SIGNUP_STEPS[currentStepIndex - 1];
    }

    return '';
  };

  if (currentStep === GET_STARTED_STEP_ID) return null;

  const renderButtonText = () => {
    return currentStep === DOCUMENTS_STEP_ID
      ? 'Back to details'
      : 'Back a step';
  };

  return (
    <Button
      size={currentStep === DOCUMENTS_STEP_ID ? 'medium' : 'small'}
      variant="tertiary"
      onClick={() => navigateSignup({ route: getPreviousStep(currentStep) })}
      disabled={isStateFetching || isStateLoading}
    >
      <IconAngleLeft />
      {renderButtonText()}
    </Button>
  );
};

export default BackToStep;
